import { ArrowUpRight, Check } from "lucide-react";
import { SERVICES } from "@/lib/site";

// Bento grid spans for 6 services on lg:
// row 1: 4 | 2
// row 2: 2 | 4
// row 3: 3 | 3
const SPANS = [
  "lg:col-span-4",
  "lg:col-span-2",
  "lg:col-span-2",
  "lg:col-span-4",
  "lg:col-span-3",
  "lg:col-span-3",
];

const LARGE_INDEXES = new Set([0, 3]);

export default function Services() {
  return (
    <section id="servizi" data-testid="services-section" className="relative py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end mb-14">
          <div className="lg:col-span-7 reveal">
            <SectionLabel>I servizi</SectionLabel>
            <h2 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tighter text-brand-ink mt-4 text-balance">
              Sei servizi.<br />
              <span className="text-brand-primary">Un unico standard:</span> l'eccellenza.
            </h2>
          </div>
          <div className="lg:col-span-5 lg:pl-10 reveal reveal-delay-1">
            <p className="text-lg text-brand-body leading-relaxed">
              Non facciamo "anche traslochi". Facciamo <strong className="text-brand-ink">solo</strong> traslochi e sgomberi.
              Per questo li facciamo come nessun altro a Caltanissetta, in tutta la Sicilia e fino al Nord Italia.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-5">
          {SERVICES.map((s, idx) => (
            <ServiceCard
              key={s.key}
              service={s}
              span={SPANS[idx] || "lg:col-span-3"}
              large={LARGE_INDEXES.has(idx)}
              delay={idx}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

function SectionLabel({ children }) {
  return (
    <div className="inline-flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase font-bold text-brand-primary">
      <span className="w-8 h-px bg-brand-primary" />
      {children}
    </div>
  );
}

function ServiceCard({ service, span, large, delay }) {
  return (
    <article
      data-testid={`service-card-${service.key}`}
      className={`group relative ${span} card-lift bg-white border border-brand-line rounded-2xl overflow-hidden reveal reveal-delay-${(delay % 4) + 1}`}
    >
      <div className={`relative overflow-hidden ${large ? "h-72 lg:h-80" : "h-56"}`}>
        <img
          src={service.img}
          alt={service.title}
          loading="lazy"
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-brand-ink/75 via-brand-ink/15 to-transparent" />
        <div className="absolute top-4 left-4 px-3 py-1 bg-white/95 text-brand-primary text-[11px] uppercase tracking-[0.18em] font-bold rounded-full">
          {service.label}
        </div>
        <div className="absolute bottom-5 left-5 right-5">
          <h3 className="font-display font-extrabold text-2xl lg:text-3xl text-white tracking-tight">
            {service.title}
          </h3>
        </div>
      </div>
      <div className="p-6 lg:p-7">
        <p className="text-brand-body leading-relaxed">{service.desc}</p>
        <ul className="mt-5 space-y-2.5">
          {service.points.map((p) => (
            <li key={p} className="flex items-start gap-2.5 text-sm text-brand-ink">
              <span className="mt-0.5 w-5 h-5 rounded-full bg-brand-primary/10 text-brand-primary flex items-center justify-center shrink-0">
                <Check className="w-3 h-3" />
              </span>
              <span className="font-medium">{p}</span>
            </li>
          ))}
        </ul>
        <a
          href="#preventivo"
          className="inline-flex items-center gap-2 mt-6 text-sm font-bold text-brand-primary group-hover:gap-3 transition-all"
          data-testid={`service-cta-${service.key}`}
        >
          Richiedi preventivo per {service.label}
          <ArrowUpRight className="w-4 h-4" />
        </a>
      </div>
    </article>
  );
}
